<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ props }">
      <v-icon v-bind="props" class="info-tooltip-icon">
        mdi-information-outline
      </v-icon>
    </template>
    <div>
      {{ title }}
      <ul class="pl-2" :class="{ 'no-bullets': hideBullets }">
        <li v-if="firstParagraph">
          {{ firstParagraph }}
        </li>
        <li v-if="secondParagraph">
          {{ secondParagraph }}
        </li>
      </ul>
    </div>
  </v-tooltip>
</template>
<script setup>
const props = defineProps({
  title: {
    type: String,
    required: false,
  },
  firstParagraph: {
    type: String,
    required: false,
  },
  secondParagraph: {
    type: String,
    required: false,
  },
  hideBullets: {
    type: Boolean,
    default: false,
  },
});
</script>
<style scoped>
.info-tooltip-icon {
  color: rgb(var(--v-theme-on-surface));
}

.no-bullets {
  list-style: none !important;
  padding-left: 0 !important;
}
</style>
